import { useEffect, useState } from "react";
import { GetInventoryLocations } from "../../services/InventoryTrackerService";

// ENB-584: inventory locations as full paths ("Warehouse 1 > Rack 6 > Shelf 4"), the text saved on
// stock rows and supply order lines. Same contract as useDropdownList: a saved value that is no
// longer an active location is appended so existing records still show it.
const useInventoryLocationList = (currentValue = "") => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const response = await GetInventoryLocations();
        if (!cancelled) setOptions((response?.results || []).map((location) => location.fullPath));
      } catch (error) {
        console.error("Error loading inventory locations:", error);
        if (!cancelled) setOptions([]);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  const saved = (Array.isArray(currentValue) ? currentValue : [currentValue]).filter(Boolean);
  const missing = [...new Set(saved)].filter((value) => !options.includes(value));
  return missing.length ? [...options, ...missing] : options;
};

export default useInventoryLocationList;
